module.exports = __webpack_public_path__ + "img/dotr.dba204e5.jpg";